










































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import GridTable from '@/components/common/GridTable.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderHoldByReservationGrids from '@/components/order/mixins/OrderHoldByReservationGrids';

import {Component, Mixins, Ref} from 'vue-property-decorator';
import {OrderOptionChangeStatusOption, GetOrderOptionCheckReservationRequest} from 'supporter';
import { i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/commonUtils';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';

@Component({
  components: {OrderContentTop, PageTitle, GridTable, ItemTable}
})
export default class OrderHoldDelivery extends Mixins(OrderHoldByReservationGrids, OrderGridBrokenFreeGiftMixin) {
	@Ref('gridBottom')
	private readonly gridRef: ItemTable;

	private orderListContent: any = [];
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private normalCount: number = 0;
  private delayedCount: number = 0;
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeHelpData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: true
  };
  private searchDateTypeArr: any[] = [
    {
      value: 'ORDER_YMDT',
      name: '주문일시'
    },
    {
      value: 'RESERVATION_START_YMDT',
      name: '예약판매 시작일'
    }
  ];
  private created(): void {
    this.exchangeHelpData = i18nObjectByKey(this, this.exchangeHelpData, 'title');
  }
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }

  private changeStatus(e: any) {
    const targetStatusType = $(e.target).attr('to')||$(e.currentTarget).attr('to');
    if ((this.$refs.gridBottom as any).getCheckedRows().length === 0) {
      alert(this.$t('ORDER_LIST_GRIDS_PAY_DONE_NOT_CHECK_ROW_ALERT'));
      return;
    }

    const checkedRowList = this.getCheckedRows();
    for (let i = 0;i<checkedRowList.length;i++) {
      if(checkedRowList[i].orderStatusType != 'DEPOSIT_WAIT') {
        alert('주문상태를 확인해 주세요.');
        return;
      }
    }

    const confirmMessage: any = this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE');

    if (!confirm(confirmMessage)) {
      return;
    }

		const request = checkedRowList.map(({ orderNo }) => orderNo);
    this.$api.putPaymentsConfirm(request).then(() => {
      alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
      this.search(1, this.size);
    });
  }
  private getCheckedRows(): any {
    return (this.$refs.gridBottom as any).getCheckedRows();
  }

  public initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });

		if (!this.theExcelDownIfo?.excelDownInfo) return;

    this.theExcelDownIfo.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.theExcelDownIfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.theExcelDownIfo.formatters = this.excelDownInfo.formatters;
    this.theExcelDownIfo.fileName = 'order_';
  }
  private orderOptionReserveToNormal() {
		const checkedOrderNo = (this.$refs.gridBottom as any).getCheckedRows().map((row: any) => row.orderNo);
		const checkedOptionNos = this.orderListContent.filter(({ orderNo }) => checkedOrderNo.some(no => no === orderNo)).map(({ orderProductOptionNo }) => orderProductOptionNo);

    if (checkedOrderNo.length === 0) {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_EMPTY'));
      return;
    }

    const obj: GetOrderOptionCheckReservationRequest = {
      params: {
        orderOptionNos: checkedOptionNos.join(',')
      }
    };

    this.$api.getOrderOptionCheckReservation(obj).then(({data}: any) => {
      if (data?.reservation) {
        if (!confirm(this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_RESERVATION_TRUE') as any)) {
          return;
        }
      }

      this.$api.putOrderOptionReserveToNormal(obj).then(() => {
        alert(this.$t('ORDER_ORDER_CONTENT_TOP_PUT_SUCCESS'));
        this.search(1, this.initPageSize);
      });
    });
  }
  private orderOptionChangeStatus() {
    let checkedRowList = (this.$refs.gridBottom as any).getCheckedRowKeys();
    if (checkedRowList.length === 0) {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_EMPTY'));

      return;
    }
    for (let i = 0; i < checkedRowList.length; i++) {
      if ((this.$refs.gridBottom as any).getRow(checkedRowList[i]).orderStatusType != 'DEPOSIT_WAIT') {
        alert(this.$t('ORDER_ORDER_CONTENT_TOP_HOLD_BY_RESERVATION_CHECK_ORDER_STATUS'));
        return;
      }
    }
    const flag = checkedRowList.map((row: any) => (this.$refs.gridBottom as any).getRow(row).taskMessage).every((value: any) => value === false);
    if (!flag) {
      return;
    }
    let optionArr: OrderOptionChangeStatusOption[] = [];
    checkedRowList.map((row: any) => {
      let theObj = (this.$refs.gridBottom as any).getRow(row);
      optionArr.push({
        deliveryCompanyType: theObj.deliveryCompanyType,
        invoiceNo: theObj.invoiceNo,
        mallNo: theObj.mallNo,
        orderOptionNo: theObj.orderProductOptionNo
      });
    });
    let obj: any = {
      data: {
        orderStatusType: 'PAY_DONE',
        options: optionArr
      }
    };
    this.$api.putOrderOptionChangeStatus(obj).then(() => {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_PUT_SUCCESS'));
      this.search(1, this.initPageSize);
    });
  }
  private handleCancel(): void {}
  private handleSearch(e: any, page: number = 1, size: number): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.search(page, size);
  }
  private search(page: number = 1, size: number): void {
    if (this.request.params.orderStatusTypes.length === 0) {
      alert('ORDER_CONTENT_TOP_ORDER_STATUS_TYPES_EMPTY_ALERT');
      return;
    }
    this.request.params.page = page;
    this.request.params.size = size || this.initPageSize;
    this.request.params.holdByReservation = true;
    $('#loading').show();
    this.gridProps.options.rowHeaders = ['checkbox'];
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res: any) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'recommenderId', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let midRow = [
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'shippingNo',
            'deliveryAmtInAdvanceYn',
            'deliveryConditionType',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn', 'totalBuyAmt'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

					// 예약주문관리 > 사은품인 경우 그리드 체크박스 disabled 처리
          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)].map(({ _attributes, isFreeGift, ...rest }) => ({
	          ...rest,
	          isFreeGift,
	          _attributes: {
							..._attributes,
		          checkDisabled: isFreeGift,
	          }
          }));
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally(() => {
        $('#loading').hide();
      });
  }
  private contentBottomOption: any = {
    name: 'benefit_list',
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    autoHeight: false,
    excelDownInfo: this.theExcelDownIfo
  };
}
